module.exports = __webpack_public_path__ + "static/media/logo.98aa2763.png";